import { FC } from 'react';
import { useMenuContext } from '#baseMenu/hooks';

const ContentWrapper: FC = () => {
  const { Content, isContentLoaded } = useMenuContext();

  if (!isContentLoaded) {
    return null;
  }

  return <Content />;
};

export { ContentWrapper };
